import { Form as FinalForm } from 'react-final-form'
import { useTranslation } from 'react-i18next'

import { Form, Button, DatePicker, NumberField } from '@/ui'
import Field from '@/components/Field'
import { required } from '@/helpers/validators'

interface SpecificValueInputProps {
  type?: 'date' | 'number'
  metadata?: any
  onSubmit: (value: string | number) => void
}

const SpecificValueInput = ({
  type = 'number',
  metadata,
  onSubmit,
}: SpecificValueInputProps) => {
  const { t } = useTranslation()

  const as = {
    date: DatePicker,
    number: NumberField,
  }[type]

  return (
    <FinalForm
      validate={required(['value'])}
      onSubmit={(values: any) => {
        onSubmit(values.value)
      }}
      render={({ handleSubmit, invalid }) => (
        <Form>
          <Field
            required
            as={as}
            name="value"
            label={t('Value')}
            {...metadata}
          />

          <Button
            disabled={invalid}
            onClick={handleSubmit}
            content={t('Add filter')}
          />
        </Form>
      )}
    />
  )
}

export default SpecificValueInput
